<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <v-switch
              v-model="enable_featured_sponsors_landing"
              label="Habilitar patrocinadores"
            ></v-switch>
            <v-radio-group
              v-model="type_featured_sponsors"
              column
              :disabled="!enable_featured_sponsors_landing"
            >
              <v-sheet outlined class="pa-4 mb-4">
                <v-radio
                  label="Usar patrocinadores destacados de alguna edición"
                  value="edition"
                ></v-radio>

                <v-select
                  class="mt-8"
                  :items="editions"
                  label="Edición"
                  outlined
                  v-model="edition_selected_featured_sponsors"
                  :disabled="type_featured_sponsors!='edition'"
                  item-value="id"
                  item-text="name"
                ></v-select>
              </v-sheet>

              <v-sheet outlined class="pa-4">
                <v-radio
                  label="Personalizado"
                  value="custom"
                ></v-radio>
              </v-sheet>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationFeaturedSponsorsSection()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  // const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationFeaturedSponsorsSection',
    data: () => ({
      loading:true,
      loading_update: false,
      landing:[],
      editions: [],

      enable_featured_sponsors_landing: false,
      type_featured_sponsors: 'edition',
      edition_selected_featured_sponsors: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getEditions(){
        await axios.get('admin/editions').then(response =>{
          this.editions = response.data
          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing

          this.enable_featured_sponsors_landing   = (this.landing.enable_featured_sponsors_landing)?true:false
          this.type_featured_sponsors             = this.landing.type_featured_sponsors
          this.edition_selected_featured_sponsors = this.landing.edition_selected_featured_sponsors
          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationFeaturedSponsorsSection(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('enable_featured_sponsors_landing', (this.enable_featured_sponsors_landing)?1:0)
        formData.append('type_featured_sponsors', this.type_featured_sponsors)
        formData.append('edition_selected_featured_sponsors', this.edition_selected_featured_sponsors)

        try {
          await axios({
            method: 'post',
            url: 'admin/landing/featured-sponsors-section',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationLanding' })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      //-------My Project-----------
      onProjectImageChange() {
        this.url_cover_image_main_section = URL.createObjectURL(this.cover_image_main_section);
      },

      deleteProjectImage(){
        this.cover_image_main_section=null
        this.url_cover_image_main_section=null
      }
    },

    created(){
      this.getEditions()
      this.getCustomization()
    },
  }
</script>
